module.exports = __webpack_public_path__ + "static/media/order-completed-5.d45a9fb9.png";